import { IQueryMediator, ICommand } from 'core-ts-types';
import { IChangedBusyTimeDatasource } from '../datastore/time/changed_busy_time_datasource';
import { IDefineCommand } from 'core-ts-types';
import { TimeOccurrenceDataSource } from '../datastore/time/time_datasource';
import { ITimeOccurrenceDatatype, IRawTimeOccurrenceDatatype } from '../datastore/time/data_types';
import { IChangedBusyTime } from '../builders/time/changed_busy_time_builder';
import * as _4 from 'lodash4';

// Given an array of existing TimeOccurrence blocks, add a new empty TimeOccurrence to the array.
function resetChangedBusyTimeCommand(
  defineCommand: any,
  ngChangedBusyTimeDatasource: IChangedBusyTimeDatasource,
  ngTimeOccurrenceDataSource: TimeOccurrenceDataSource,
  defineCommandORM: IDefineCommand,
  addRawTimeCommand: ICommand,
  QueryMediator: IQueryMediator
) {
  return defineCommandORM('resetChangedBusyTimeCommand', function resetChangedBusyTimeCommand(deferred: any) {
    const original = _4.find(ngChangedBusyTimeDatasource.read(), (item: any) => item.is_new_time === false);

    //Revert day of week to reflect in day picker
    original.originalTimeObj.day_of_week = original.originalTimeObj.day.ordinal;
    ngTimeOccurrenceDataSource.deleteTime(original.originalTimeObj);
    ngChangedBusyTimeDatasource.del(original.id);
    addRawTimeCommand(original.originalTimeObj);

    QueryMediator.runQueries(ngTimeOccurrenceDataSource);
    deferred.resolve(ngChangedBusyTimeDatasource);
  });
}

angular.module('ui-ng-calendar').factory('resetChangedBusyTimeCommand', resetChangedBusyTimeCommand);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/commands/reset_changed_busy_time.ts